import React, { useState, useEffect } from "react";

import {
  ResultProvider,
  getResultOrigin,
  TYPES,
  SUBTYPES,
  TableRanking,
  PactometroCheckSimple
} from "@atresmedia/elections_modules_library";

import cintillos from "../../components/cintillo/cintillos";
import "./rankingPactometro.scss";

const selecteds = [];
const RankingPactometro = ({ match }) => {
  const { year, type, electionNumber, placesIds, community } = match.params;

  const place = type === TYPES.REGIONAL ? community : placesIds;
  const Cintillo = cintillos[place];

  const [resultOrigin, setResultOrigin] = useState({});
  useEffect(() => {
    getResultOrigin(year, type, electionNumber, place)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  return (
    <div className="rankingPactometroPage">
      <Cintillo rightSide="PACTÓMETRO"></Cintillo>
      {resultOrigin && resultOrigin.primary && (
        <ResultProvider
          electionPlace={place}
          active={resultOrigin.primary.active}
          year={year}
          type={type}
          subtype={type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE}
          electionNumber={electionNumber}
          placeId={place}
        >
          {dataResult => (
            <ResultProvider
              electionPlace={place}
              active={resultOrigin.historic.active}
              year={resultOrigin.historic.year}
              type={type}
              subtype={
                type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE
              }
              electionNumber={resultOrigin.historic.numElection}
              placeId={place}
            >
              {oldData =>
                dataResult.partiesResult ? (
                  <div className="rankingPactometroWrapper">
                    <div className="rankingWrapper">
                      <TableRanking
                        currentData={dataResult}
                        pastData={oldData}
                        year={year}
                        electionNumber={electionNumber}
                        electionType={type}
                        placeId={place}
                        titleColumn={"2020"}
                        titleColumn2={"2016"}
                      />
                    </div>
                    <div className="pactometroWrapper">
                      <PactometroCheckSimple
                        selecteds={selecteds}
                        totalSeat={dataResult.totalSeats}
                        seatData={dataResult.partiesResult}
                        legend="*Pincha sobre cada partido para sumar sus escaños"
                      />
                    </div>
                  </div>
                ) : (
                  <p>Cargando...</p>
                )
              }
            </ResultProvider>
          )}
        </ResultProvider>
      )}
    </div>
  );
};

export default RankingPactometro;
